export default {
  newFeatures: 'New Features',
  events: 'Events',
  tips: 'Tips',
  companyNews: 'Company News',
  other: 'Other'
}
